import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TipiTemplateFormComponent } from './dialogs/form/form.component';
import { TipiTemplateComponent } from './tipi-template.component';


const routes: Routes = [
  {
    path: '', component: TipiTemplateComponent
  },
  {
    path: 'inserisci', component: TipiTemplateFormComponent,
    data: { title: 'Inserimento TipiTemplate' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TipiTemplateRoutingModule { }
